module.exports = __webpack_public_path__ + "img/payment_success.bbb0df03.svg";